import React from "react";
import {Box, Checkbox, FormControlLabel, Slider, Stack, Switch, Typography} from "@mui/material";
import {UI} from "../../uiTokens";
import {checkboxSx, controlLabelSx, switchSx} from "../editMenuStyles";

/** The main heading at the top of an edit-menu tab. */
export const SectionHeader = ({title, description}) => (
    <Box>
        <Typography sx={{fontWeight: 700, fontSize: 14, color: UI.ink}}>{title}</Typography>
        {description && (
            <Typography sx={{mt: 0.25, fontSize: 12, color: UI.muted, lineHeight: 1.45}}>{description}</Typography>
        )}
    </Box>
);

/** A smaller heading for a group of controls, with an optional action on the right. */
export const SubSectionHeader = ({title, description, action}) => (
    <Box>
        <Stack direction="row" alignItems="center" gap={1}>
            <Typography sx={{flex: 1, fontWeight: 700, fontSize: 12.5, color: UI.ink}}>{title}</Typography>
            {action}
        </Stack>
        {description && (
            <Typography sx={{mt: 0.25, fontSize: 11, color: UI.muted, lineHeight: 1.35}}>{description}</Typography>
        )}
    </Box>
);

/** A labelled slider with its current value shown on the right. */
export const SliderRow = ({label, display, ...sliderProps}) => (
    <Box>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{fontSize: 12.5, fontWeight: 600, color: UI.ink}}>{label}</Typography>
            <Typography sx={{fontSize: 11, color: UI.muted}}>{display}</Typography>
        </Stack>
        <Slider size="small" sx={{color: UI.accent, display: "block", width: "calc(100% - 20px)", mx: "10px"}} {...sliderProps} />
    </Box>
);

/** A labelled switch / checkbox row with consistent accent styling. */
export const ToggleRow = ({label, checked, onChange, onBlur, control = "switch"}) => {
    const Control = control === "checkbox" ? Checkbox : Switch;
    return (
        <FormControlLabel
            sx={{ml: -0.5, mr: 0}}
            control={
                <Control
                    size="small"
                    checked={!!checked}
                    onChange={onChange}
                    onBlur={onBlur}
                    sx={control === "checkbox" ? checkboxSx : switchSx}
                />
            }
            label={<Typography sx={controlLabelSx}>{label}</Typography>}
        />
    );
};
